import React, { useEffect, useState } from 'react'

import {
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Typography,
} from '@material-ui/core'
import LargeToolbar from 'app/components/LargeToolbar'
import { FormattedMessage, useIntl } from 'react-intl'
import effects from 'app/effects/effects'
import './styles/social-media-integrations.css'
import {
  SOCIAL_PROVIDER_KEY_FACEBOOK,
  SOCIAL_PROVIDER_ALIAS_FACEBOOK,
  SOCIAL_PROVIDER_LOGIN_URL_FACEBOOK,
  SOCIAL_PROVIDER_KEY_TWITTER,
  SOCIAL_PROVIDER_ALIAS_TWITTER,
  SOCIAL_PROVIDER_KEY_INSTAGRAM,
  SOCIAL_PROVIDER_ALIAS_INSTAGRAM,
  SOCIAL_PROVIDER_KEY_LINKEDIN,
  SOCIAL_PROVIDER_ALIAS_LINKEDIN,
  SOCIAL_PROVIDER_TWITTER_KEY,
  SOCIAL_PROVIDER_LOGIN_URL_TWITTER,
  SOCIAL_PROVIDER_LOGIN_URL_INSTAGRAM,
  SOCIAL_PROVIDER_LOGIN_URL_LINKEDIN,
  REDIRECT_SOCIAL_PROVIDER_LOGIN_URL_LINKEDIN,
  SOCIAL_PROVIDER_KEY_LINE,
  SOCIAL_PROVIDER_ALIAS_LINE,
} from './configs/socialMediaIntegrationConfig'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import CancelButton from '../../../components/buttons/CancelButton'
import { usePlace } from '../../../../commons/usePlace'
import { useAppName } from 'commons/usePartner'
import SocialMediaPagesModal from './components/modals/SocialMediaPagesModal/SocialMediaPagesModal'
import { getItem, setItem } from '../../../utilize/localStorage'
import {
  __,
  always,
  compose,
  either,
  equals,
  filter,
  ifElse,
  includes,
  isEmpty,
  isNil,
  map,
} from 'ramda'
import clsx from 'clsx'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { SECONDARY, CANCEL, INFO } from 'app/constants/button'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import LineRequestDialog from '../LineRequestDialog'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import SocialMediaProvider from './components/social-media-provider/SocialMediaProvider'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'

const isNullOrFalse = either(isNil, equals(false))

const SocialMediaIntegrations = () => {
  const dispatch = useDispatch()
  const { mes_4687_FE_line_integration } = useFeatureFlag()
  const place = usePlace()
  const appName = useAppName()
  const [isSocialMediaPagesModalOpened, setIsSocialMediaPagesModalOpened] =
    useState(false)
  const [isTwitterOverloadedModalClosed, setIsTwitterOverloadedModalClosed] =
    useState(false)
  const [isTwitterServerUnavailable, setIsTwitterServersUnavailable] =
    useState(false)

  const [isComingSoonModalOpened, setIsComingSoonModalOpened] = useState(false)
  const [isInstagramModal, setIsInstagramModal] = useState(false)
  const [openLineDialog, setOpenLineDialog] = useState(false)

  const [socialProviders, setSocialProviders] = useState([
    {
      imgPath:
        '/assets/images/social-integrations/social-media-provider-facebook.svg',
      nameTranslationId: 'socialMediaIntegrations.provider.facebook.title',
      subTitleId: 'socialMediaIntegrations.facbook.sub.title',
      descriptionTranslationId:
        'socialMediaIntegrations.provider.facebook.description',
      connected: false,
      qrUrl: null,
      key: SOCIAL_PROVIDER_KEY_FACEBOOK,
      alias: SOCIAL_PROVIDER_ALIAS_FACEBOOK,
      status: 1, //status use only line other social just default 1 for connected
      onClick: (e, socialProvider) =>
        handleFacebookProviderClick(e, socialProvider),
      onButtonClick: (socialProvider) =>
        handleFacebookProviderButtonClick(socialProvider),
    },
    {
      imgPath:
        '/assets/images/social-integrations/social-media-provider-twitter.svg',
      nameTranslationId: 'socialMediaIntegrations.provider.twitter.title',
      subTitleId: 'socialMediaIntegrations.twitter.sub.title',
      connected: false,
      qrUrl: null,
      key: SOCIAL_PROVIDER_KEY_TWITTER,
      alias: SOCIAL_PROVIDER_ALIAS_TWITTER,
      status: 1, //status use only line other social just default 1 for connected
      onButtonClick: (socialProvider) =>
        handleTwitterProviderButtonClick(socialProvider),
    },
    {
      imgPath:
        '/assets/images/social-integrations/social-media-provider-instagram.svg',
      nameTranslationId: 'socialMediaIntegrations.provider.instagram.title',
      subTitleId: 'socialMediaIntegrations.instagram.sub.title',
      connected: false,
      qrUrl: null,
      key: SOCIAL_PROVIDER_KEY_INSTAGRAM,
      alias: SOCIAL_PROVIDER_ALIAS_INSTAGRAM,
      status: 1, //status use only line other social just default 1 for connected
      onClick: (e, socialProvider) =>
        handleInstagramProviderClick(e, socialProvider),
      onButtonClick: (socialProvider) =>
        handleInstagramProviderButtonClick(socialProvider),
    },
    {
      imgPath:
        '/assets/images/social-integrations/social-media-provider-linkedin.png',
      nameTranslationId: 'socialMediaIntegrations.provider.linkedin.title',
      subTitleId: 'socialMediaIntegrations.linkedin.sub.title',
      connected: false,
      qrUrl: null,
      key: SOCIAL_PROVIDER_KEY_LINKEDIN,
      alias: SOCIAL_PROVIDER_ALIAS_LINKEDIN,
      status: 1, //status use only line other social just default 1 for connected
      onButtonClick: (socialProvider) =>
        handleLinkedinProviderButtonClick(socialProvider),
    },
    ...(mes_4687_FE_line_integration
      ? [
          {
            imgPath: '/assets/images/social-integrations/line-icon.svg',
            nameTranslationId: 'crm.form.lineProfile',
            subTitleId: 'socialMediaIntegrations.line.sub.title',
            connected: false,
            qrUrl: null,
            key: SOCIAL_PROVIDER_KEY_LINE,
            alias: SOCIAL_PROVIDER_ALIAS_LINE,
            status: undefined,
            onButtonClick: (socialProvider) =>
              handleLineProviderButtonClick(socialProvider),
          },
        ]
      : []),
  ])

  const [selectedSocialProvider, setSelectedSocialProvider] = useState({})
  const [isDisconnectModalOpened, setIsDisconnectModalOpened] = useState(false)
  const [isLoaded, setIsLoaded] = useState(true)

  useEffect(() => {
    let urlSearch = new URLSearchParams(window.location.search)
    if (urlSearch.has('code')) {
      let socialProviderKey
      if (!urlSearch.has('state')) {
        socialProviderKey = SOCIAL_PROVIDER_KEY_FACEBOOK
      } else {
        if (parseInt(urlSearch.get('state')) === 4)
          socialProviderKey = SOCIAL_PROVIDER_KEY_INSTAGRAM
        else if (
          urlSearch.has('state') &&
          parseInt(urlSearch.get('state')) === 5
        )
          socialProviderKey = SOCIAL_PROVIDER_KEY_LINKEDIN
      }
      effects.apis
        .connectSocialProvider({
          code: urlSearch.get('code'),
          placeId: place.id,
          socialProviderKey: socialProviderKey,
        })
        .then(() => fetchSettings())
        .finally(() => {
          if (!urlSearch.has('state')) {
            handleFacebookPagesModalOpening()
          } else {
            if (parseInt(urlSearch.get('state')) === 4) {
              handleInstagramPagesModalOpening()
            }
          }
        })
    }
    fetchSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let urlTokens = new URLSearchParams(window.location.search)

    if (urlTokens.has('oauth_token') && urlTokens.has('oauth_verifier')) {
      effects.apis
        .connectionSocialProviderTwitter({
          oauthToken: urlTokens.get('oauth_token'),
          oauthVerifier: urlTokens.get('oauth_verifier'),
          type: SOCIAL_PROVIDER_KEY_TWITTER,
          placeId: place.id,
        })
        .then(() => {
          fetchSettings()
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSocialMediaProviderByKey = (providerKey) => {
    return socialProviders.find((element) => element.key === providerKey)
  }

  const handleFacebookProviderButtonClick = (socialProvider) => {
    let facebookSocialProvider = getSocialMediaProviderByKey(
      SOCIAL_PROVIDER_KEY_FACEBOOK,
    )
    if (!facebookSocialProvider.connected) {
      window.location.href = SOCIAL_PROVIDER_LOGIN_URL_FACEBOOK
    } else {
      setSelectedSocialProvider(socialProvider)
      openDisconnectConfirmationModal(socialProvider)
    }
  }

  const getTwitterToken = async () => {
    try {
      return await effects.apis.integration.getTwitterToken()
    } catch (error) {
      dispatch(MessageAlert.showNetworkError(formatMessage)(error))
    }
  }

  const handleTwitterProviderButtonClick = async (socialProvider) => {
    if (mes_4687_FE_line_integration) {
      let twitterProvider = getSocialMediaProviderByKey(
        SOCIAL_PROVIDER_KEY_TWITTER,
      )

      if (!twitterProvider.connected) {
        const { token } = await getTwitterToken()
        window.location.href =
          SOCIAL_PROVIDER_LOGIN_URL_TWITTER + `oauth_token=${token}`
      } else if (!twitterProvider) {
        setIsTwitterServersUnavailable(true)
        setIsTwitterOverloadedModalClosed(false)
      } else {
        setSelectedSocialProvider(socialProvider)
        openDisconnectConfirmationModal(socialProvider)
      }
    } else {
      let twitterProvider = getSocialMediaProviderByKey(
        SOCIAL_PROVIDER_KEY_TWITTER,
      )
      const token = getItem(SOCIAL_PROVIDER_TWITTER_KEY)
      if (!twitterProvider.connected && token) {
        window.location.href =
          SOCIAL_PROVIDER_LOGIN_URL_TWITTER + `oauth_token=${token}`
      } else if (!twitterProvider && !token) {
        setIsTwitterServersUnavailable(true)
        setIsTwitterOverloadedModalClosed(false)
      } else {
        setSelectedSocialProvider(socialProvider)
        openDisconnectConfirmationModal(socialProvider)
      }
    }
  }

  const handleInstagramProviderButtonClick = (socialProvider) => {
    const instagramProvider = getSocialMediaProviderByKey(
      SOCIAL_PROVIDER_KEY_INSTAGRAM,
    )
    if (!instagramProvider.connected) {
      window.location.href = SOCIAL_PROVIDER_LOGIN_URL_INSTAGRAM
    } else {
      setSelectedSocialProvider(socialProvider)
      openDisconnectConfirmationModal(socialProvider)
    }
  }

  const handleLinkedinProviderButtonClick = (socialProvider) => {
    let linkedinProvider = getSocialMediaProviderByKey(
      SOCIAL_PROVIDER_KEY_LINKEDIN,
    )
    if (!linkedinProvider.connected) {
      window.location.href = SOCIAL_PROVIDER_LOGIN_URL_LINKEDIN.concat(
        encodeURI(REDIRECT_SOCIAL_PROVIDER_LOGIN_URL_LINKEDIN),
      )
    } else {
      setSelectedSocialProvider(socialProvider)
      openDisconnectConfirmationModal(socialProvider)
    }
  }

  const handleLineProviderButtonClick = (socialProvider) => {
    let lineProvider = getSocialMediaProviderByKey(SOCIAL_PROVIDER_KEY_LINE)
    if (!lineProvider.connected) {
      setOpenLineDialog(true)
    } else {
      setSelectedSocialProvider(socialProvider)
      openDisconnectConfirmationModal(socialProvider)
    }
  }

  const disconnectSocialProvider = (socialProvider) => {
    socialProvider.connected = false
    setSocialProviders(socialProviders)
    fetchSettings()
    closeDisconnectConfirmationModal()
  }

  const handleDisconnect = (socialProviderKey = undefined) => {
    if (!socialProviderKey) return

    if (socialProviderKey === SOCIAL_PROVIDER_KEY_LINE) {
      effects.apis.integration.lineDisconnect().then(() => {
        setSocialProviders(socialProviders)
        setIsLoaded(true)
        fetchSettings()
        closeDisconnectConfirmationModal()
      })
    } else {
      effects.apis
        .disconnectSocialProvider({
          socialProviderKey: socialProviderKey,
          placeId: place.id,
        })
        .then(() => {
          const currentSocialProvider = socialProviders.find(
            (element) => element.key === socialProviderKey,
          )
          disconnectSocialProvider(currentSocialProvider)
        })
    }
  }

  const fetchSettings = () => {
    if (mes_4687_FE_line_integration) {
      effects.apis.integration.getSetting({ placeId: place.id }).then((res) => {
        setItem(SOCIAL_PROVIDER_TWITTER_KEY, res.twitterConnected?.token)
        setIsLoaded(false)
        socialProviders.map((provider) => {
          if (provider.key === SOCIAL_PROVIDER_KEY_LINE) {
            provider.status = res.lineConnected?.status
            provider.qrUrl = res.lineConnected?.qr
            provider.credits = res.lineConnected?.credits
            provider.usaged = res.lineConnected?.usaged
            provider.connected = includes(res.lineConnected?.status, [1, 0])
          } else if (provider.key === SOCIAL_PROVIDER_KEY_TWITTER) {
            provider.connected = !isNullOrFalse(res.twitterConnected)
          } else {
            provider.connected = res[`${provider.alias}Connected`]
          }

          return provider
        })
        setSocialProviders([...socialProviders])
      })
    } else {
      effects.apis
        .getSocialIntegrationSettings({ placeId: place.id })
        .then((res) => {
          setItem(SOCIAL_PROVIDER_TWITTER_KEY, res.twitterToken)
          setIsLoaded(false)
          socialProviders.map((provider) => {
            provider.connected = res[`${provider.alias}Connected`]
            return provider
          })
          setSocialProviders([...socialProviders])
        })
    }
  }

  const { formatMessage } = useIntl()
  const openDisconnectConfirmationModal = (socialProvider) => {
    setSelectedSocialProvider(socialProvider)
    setIsDisconnectModalOpened(true)
  }
  const closeDisconnectConfirmationModal = () => {
    setSelectedSocialProvider({})
    setIsDisconnectModalOpened(false)
  }

  const handleFacebookModalClose = () => setIsSocialMediaPagesModalOpened(false)

  const handleFacebookPagesModalOpening = () => {
    setIsSocialMediaPagesModalOpened(true)
    setIsInstagramModal(false)
  }

  const handleInstagramPagesModalOpening = () => {
    setIsInstagramModal(true)
    setIsSocialMediaPagesModalOpened(true)
  }

  const handleFacebookProviderClick = (e, socialProvider) => {
    e.persist()
    handleFacebookPagesModalOpening()
  }

  const handleInstagramProviderClick = (e, socialProvider) => {
    e.persist()
    if (
      socialProvider.connected &&
      e?.target &&
      !e.target.classList.contains('social-media-provider-button')
    ) {
      handleInstagramPagesModalOpening()
    }
  }

  const handleTwitterUnavailableModalClose = () =>
    setIsTwitterOverloadedModalClosed(true)

  const getLineTextBtn = (provider) => {
    switch (provider.status) {
      case 2:
        return formatMessage({ id: 'line.review.inprogress.btn' })
      case 1:
      case 0:
        return formatMessage({
          id: 'socialMediaIntegrations.provider.button.disconnect.placeholder',
        })
      default:
        return formatMessage({ id: 'text.request' })
    }
  }

  return mes_4687_FE_line_integration ? (
    <>
      <Card className="shadow-0 border border-gray-100 rounded-8 m-5">
        <CardContent className="flex-col space-y-4 flex">
          <Typography className="font-medium text-blue-950" variant="subtitle1">
            <FormattedMessage id="navigation.settings.socialMediaIntegrations.label" />
          </Typography>
          <Typography className="text-grey-400 my-2 text-14">
            <FormattedMessage
              id="socialMediaIntegrations.page.description"
              values={{ appName }}
            />
          </Typography>
        </CardContent>
        <CardContent className="flex-col space-y-4 flex">
          {isLoaded ? (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress color="secondary" size={35} />
            </div>
          ) : (
            <div className="flex-col flex space-y-5">
              {compose(
                ifElse(isEmpty, always(null), (providers) => (
                  <Card
                    className="shadow-0 border border-gray-100 rounded-8"
                    key="provider-facebook-instagram"
                  >
                    <CardContent className="flex-col space-y-4 flex p-5">
                      <div className="w-full bg-primary-200 p-5 rounded-8 text-14 text-grey-400 space-x-2">
                        <label className="font-bold mr-2">
                          <FormattedMessage id="tour.creditsUsage.note.label" />
                        </label>
                        <label>
                          <FormattedMessage id="socialMediaIntegrations.page.note" />
                        </label>
                      </div>

                      {map((provider) => {
                        const ButtonConnect = provider.connected
                          ? OutlinedButtons
                          : ContainedButton

                        return (
                          <div
                            className={clsx(
                              'p-5',
                              provider.key === SOCIAL_PROVIDER_KEY_FACEBOOK &&
                                'border-b-1 border-gray-200',
                            )}
                            key={`provider-${provider.key}`}
                          >
                            <div className="flex items-center">
                              <div className="flex flex-1">
                                <div className="flex">
                                  <img
                                    src={provider.imgPath}
                                    alt={formatMessage({
                                      id: provider.nameTranslationId,
                                    })}
                                    className="w-[38px] h-[38px]"
                                  />
                                </div>
                                <div className="px-5  w-10/12">
                                  <div className="font-bold">
                                    <FormattedMessage
                                      id={provider.nameTranslationId}
                                    />
                                  </div>
                                  <div className="text-grey-400 text-12">
                                    <FormattedMessage
                                      id={provider.subTitleId}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex space-x-5">
                                {provider.key ===
                                  SOCIAL_PROVIDER_KEY_FACEBOOK &&
                                  provider.connected && (
                                    <OutlinedButtons
                                      id="manage-page-btn"
                                      className="bg-white rounded-8"
                                      color={INFO}
                                      type="button"
                                      onClick={(e) =>
                                        provider.onClick(e, provider)
                                      }
                                    >
                                      <FormattedMessage
                                        id={
                                          'socialMediaIntegrations.provider.button.managePage.placeholder'
                                        }
                                      />
                                    </OutlinedButtons>
                                  )}

                                <ButtonConnect
                                  id={`connect-social-${provider.key}-btn`}
                                  isLoading={isLoaded}
                                  type="button"
                                  disabled={isLoaded}
                                  className="rounded-8"
                                  color={
                                    provider.connected ? CANCEL : SECONDARY
                                  }
                                  onClick={() =>
                                    provider.onButtonClick(provider)
                                  }
                                >
                                  {provider.connected ? (
                                    <FormattedMessage
                                      id={
                                        'socialMediaIntegrations.provider.button.disconnect.placeholder'
                                      }
                                    />
                                  ) : (
                                    <FormattedMessage
                                      id={
                                        'socialMediaIntegrations.provider.button.connect.placeholder'
                                      }
                                    />
                                  )}
                                </ButtonConnect>
                              </div>
                            </div>
                          </div>
                        )
                      }, providers)}
                    </CardContent>
                  </Card>
                )),
                filter((item) =>
                  includes(item.key, [
                    SOCIAL_PROVIDER_KEY_FACEBOOK,
                    SOCIAL_PROVIDER_KEY_INSTAGRAM,
                  ]),
                ),
              )(socialProviders)}
              {compose(
                ifElse(
                  isEmpty,
                  always(null),
                  map((provider) => {
                    const ButtonConnect = provider.connected
                      ? OutlinedButtons
                      : ContainedButton
                    return (
                      <Card
                        className="shadow-0 border border-gray-100 rounded-8"
                        key={`provider-${provider.key}`}
                      >
                        <CardContent className="flex-col space-y-4 flex p-5">
                          <div className="px-5">
                            <div className="flex items-center">
                              <div className="flex flex-1">
                                <div className="flex">
                                  <img
                                    src={provider.imgPath}
                                    alt={formatMessage({
                                      id: provider.nameTranslationId,
                                    })}
                                    className="w-[38px] h-[38px]"
                                  />
                                </div>
                                <div className="px-5  w-10/12">
                                  <div className="font-bold">
                                    <FormattedMessage
                                      id={provider.nameTranslationId}
                                    />
                                    {provider.connected &&
                                      provider.key ===
                                        SOCIAL_PROVIDER_KEY_LINE && (
                                        <div className="text-red">
                                          <FormattedMessage
                                            id="delivery-quota-line"
                                            values={{
                                              usaged: provider.usaged,
                                              credits: provider.credits,
                                            }}
                                          />
                                        </div>
                                      )}
                                  </div>
                                  <div className="text-grey-400 text-12">
                                    <FormattedMessage
                                      id={provider.subTitleId}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="flex space-x-5">
                                {provider.key === SOCIAL_PROVIDER_KEY_LINE &&
                                  provider.connected && (
                                    <OutlinedButtons
                                      id="share-qrcode-line-btn"
                                      className="bg-white rounded-8"
                                      color={INFO}
                                      onClick={() => {
                                        window.open(provider.qrUrl)
                                      }}
                                    >
                                      <FormattedMessage
                                        id={'line.share.qr.btn'}
                                      />
                                    </OutlinedButtons>
                                  )}
                                <ButtonConnect
                                  id={`connect-social-${provider.key}-btn`}
                                  type="button"
                                  className="rounded-8 capitalize"
                                  disabled={provider.status === 2 || isLoaded}
                                  isLoading={isLoaded}
                                  color={
                                    provider.connected ? CANCEL : SECONDARY
                                  }
                                  onClick={() =>
                                    provider.onButtonClick(provider)
                                  }
                                >
                                  {provider.key === SOCIAL_PROVIDER_KEY_LINE ? (
                                    getLineTextBtn(provider)
                                  ) : provider.connected ? (
                                    <FormattedMessage
                                      id={
                                        'socialMediaIntegrations.provider.button.disconnect.placeholder'
                                      }
                                    />
                                  ) : (
                                    <FormattedMessage id="socialMediaIntegrations.provider.button.connect.placeholder" />
                                  )}
                                </ButtonConnect>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    )
                  }),
                ),
                filter(
                  (item) =>
                    !includes(item.key, [
                      SOCIAL_PROVIDER_KEY_FACEBOOK,
                      SOCIAL_PROVIDER_KEY_INSTAGRAM,
                    ]),
                ),
              )(socialProviders)}
              <div className="shadow-0 border border-gray-100 rounded-8 p-5 bg-green-50 text-green-500">
                <FormattedMessage id="socialMediaIntegrations.whatsapp.coming.soon" />
              </div>
            </div>
          )}
        </CardContent>
      </Card>
      {isSocialMediaPagesModalOpened && !isInstagramModal && (
        <SocialMediaPagesModal
          placeId={place.id}
          onClose={() => handleFacebookModalClose()}
          isInstagramModal={isInstagramModal}
        />
      )}
      <Dialog
        open={isDisconnectModalOpened}
        className="disconnect-provider-modal"
      >
        <DialogTitle className="disconnect-modal-title-wrapper">
          {formatMessage(
            {
              id: 'socialMediaIntegrations.provider.disconnect.modal.title',
            },
            {
              providerName:
                selectedSocialProvider.nameTranslationId &&
                formatMessage({
                  id: selectedSocialProvider.nameTranslationId,
                }),
            },
          )}
        </DialogTitle>
        <DialogContent className="disconnect-modal-description">
          <FormattedMessage id="socialMediaIntegrations.provider.disconnect.modal.text" />
        </DialogContent>
        <DialogActions className="disconnect-modal-buttons">
          <CancelButton
            onClick={() => {
              closeDisconnectConfirmationModal()
            }}
          >
            <FormattedMessage id="action.cancel" />
          </CancelButton>
          <PrimaryButton
            onClick={() => handleDisconnect(selectedSocialProvider.key)}
            autoFocus
            className="delete-btn"
          >
            <FormattedMessage id="socialMediaIntegrations.provider.button.disconnect.placeholder" />
          </PrimaryButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isComingSoonModalOpened}
        className="coming-soon-provider-modal"
      >
        <DialogTitle>
          <Icon
            color="action"
            className="coming-soon-provider-modal-close-icon"
            onClick={() => setIsComingSoonModalOpened(false)}
          >
            close
          </Icon>
          <FormattedMessage id="socialMediaIntegrations.provider.comingSoon.modal.title" />
        </DialogTitle>
        <DialogContent>
          {selectedSocialProvider.nameTranslationId &&
            formatMessage(
              {
                id: 'socialMediaIntegrations.provider.comingSoon.modal.text',
              },
              {
                providerName: formatMessage({
                  id: [selectedSocialProvider.nameTranslationId],
                }),
              },
            )}
          <PrimaryButton
            onClick={() => setIsComingSoonModalOpened(false)}
            className="coming-soon-provider-okay-button"
          >
            <FormattedMessage id="socialMediaIntegrations.provider.comingSoon.modal.button.text" />
          </PrimaryButton>
        </DialogContent>
      </Dialog>
      {!isTwitterOverloadedModalClosed && (
        <Dialog open={isTwitterServerUnavailable}>
          <DialogTitle className="twitter-server-overloaded-title">
            <FormattedMessage id="twitter.servers.overloaded.title.message" />
          </DialogTitle>
          <DialogContent className="disconnect-modal-description">
            <FormattedMessage id="twitter.servers.overloaded.text.message" />
          </DialogContent>
          <DialogActions className="twitter-servers-overloaded-button">
            <PrimaryButton onClick={handleTwitterUnavailableModalClose}>
              <FormattedMessage id="action.ok" />
            </PrimaryButton>
          </DialogActions>
        </Dialog>
      )}
      <LineRequestDialog
        open={openLineDialog}
        onClose={() => setOpenLineDialog(false)}
        onSuccess={() => {
          setIsLoaded(true)
          fetchSettings()
        }}
      />
    </>
  ) : (
    <ContentToolbarPage
      contentToolbar={
        <LargeToolbar
          content={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navigation.settings.socialMediaIntegrations.label" />
              </Typography>
            </>
          }
          right={<></>}
        />
      }
      content={
        <Card className="mx-4">
          <CardContent className="integrations-card-content">
            <div className="integration-card-content-header">
              <span className="integrations-page-description">
                <FormattedMessage
                  id={'socialMediaIntegrations.page.description'}
                  values={{ appName }}
                />
              </span>
            </div>
            {isLoaded ? (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress color="secondary" size={35} />
              </div>
            ) : (
              <div className="integrations-social-providers">
                {socialProviders.map((provider, index) => (
                  <SocialMediaProvider
                    {...provider}
                    providerKey={provider.key}
                    key={index}
                  />
                ))}
              </div>
            )}
            {isSocialMediaPagesModalOpened && !isInstagramModal && (
              <SocialMediaPagesModal
                placeId={place.id}
                onClose={() => handleFacebookModalClose()}
                isInstagramModal={isInstagramModal}
              />
            )}
            <Dialog
              open={isDisconnectModalOpened}
              className="disconnect-provider-modal"
            >
              <DialogTitle className="disconnect-modal-title-wrapper">
                {formatMessage(
                  {
                    id: 'socialMediaIntegrations.provider.disconnect.modal.title',
                  },
                  {
                    providerName:
                      selectedSocialProvider.nameTranslationId &&
                      formatMessage({
                        id: selectedSocialProvider.nameTranslationId,
                      }),
                  },
                )}
              </DialogTitle>
              <DialogContent className="disconnect-modal-description">
                <FormattedMessage id="socialMediaIntegrations.provider.disconnect.modal.text" />
              </DialogContent>
              <DialogActions className="disconnect-modal-buttons">
                <CancelButton
                  onClick={() => {
                    closeDisconnectConfirmationModal()
                  }}
                >
                  <FormattedMessage id="action.cancel" />
                </CancelButton>
                <PrimaryButton
                  onClick={() =>
                    handleDisconnect(selectedSocialProvider.providerKey)
                  }
                  autoFocus
                  className="delete-btn"
                >
                  <FormattedMessage id="socialMediaIntegrations.provider.button.disconnect.placeholder" />
                </PrimaryButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={isComingSoonModalOpened}
              className="coming-soon-provider-modal"
            >
              <DialogTitle>
                <Icon
                  color="action"
                  className="coming-soon-provider-modal-close-icon"
                  onClick={() => setIsComingSoonModalOpened(false)}
                >
                  close
                </Icon>
                <FormattedMessage id="socialMediaIntegrations.provider.comingSoon.modal.title" />
              </DialogTitle>
              <DialogContent>
                {selectedSocialProvider.nameTranslationId &&
                  formatMessage(
                    {
                      id: 'socialMediaIntegrations.provider.comingSoon.modal.text',
                    },
                    {
                      providerName: formatMessage({
                        id: [selectedSocialProvider.nameTranslationId],
                      }),
                    },
                  )}
                <PrimaryButton
                  onClick={() => setIsComingSoonModalOpened(false)}
                  className="coming-soon-provider-okay-button"
                >
                  <FormattedMessage id="socialMediaIntegrations.provider.comingSoon.modal.button.text" />
                </PrimaryButton>
              </DialogContent>
            </Dialog>
            {!isTwitterOverloadedModalClosed && (
              <Dialog open={isTwitterServerUnavailable}>
                <DialogTitle className="twitter-server-overloaded-title">
                  <FormattedMessage id="twitter.servers.overloaded.title.message" />
                </DialogTitle>
                <DialogContent className="disconnect-modal-description">
                  <FormattedMessage id="twitter.servers.overloaded.text.message" />
                </DialogContent>
                <DialogActions className="twitter-servers-overloaded-button">
                  <PrimaryButton onClick={handleTwitterUnavailableModalClose}>
                    <FormattedMessage id="action.ok" />
                  </PrimaryButton>
                </DialogActions>
              </Dialog>
            )}
          </CardContent>
        </Card>
      }
    />
  )
}

export default SocialMediaIntegrations
